/**
 * Имя протокола в списке записи: чем он отличается от соседних.
 *
 * У записи их теперь несколько — по разным шаблонам и с разной подробностью, —
 * и «Протокол», «Протокол», «Протокол» в ряд не помогают выбрать. Поэтому имя
 * шаблона, если его удалось узнать, и время, если оно есть.
 *
 * Шаблон приходит идентификатором промпта; имена промптов знает bit-auth.
 * Не узнали — не выдумываем, показываем время.
 */

function stamp(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function summaryLabel(summary, promptNames = {}) {
  if (!summary) return 'Протокол';
  const name = promptNames[summary.template] || '';
  const when = stamp(summary.created_at);
  if (name && when) return `${name} · ${when}`;
  return name || (when ? `Протокол · ${when}` : 'Протокол');
}

/**
 * Нужно ли класть протокол, сделанный из Истории, РЯДОМ с прежними.
 *
 * Первый протокол записи просто сохраняется; когда протокол уже есть, кнопка
 * «Ещё протокол» обязана добавить второй, а не затереть первый — ради этого
 * всё и делалось. Дальнейшие «Подробнее/Короче» переписывают уже новый.
 */
export function shouldAddNewSummary(item) {
  if (!item) return false;
  if (Array.isArray(item.summaries) && item.summaries.length) return true;
  return !!(item.summary && item.summary.text);
}

export default summaryLabel;
